export class Payment {
  transactionId: number = 0;
  RedactedInfo: string = '';  
  PaymentReference: string = '';
  RequestedAmount: string = '';
  CardPIN: string = ''; 
  CardholderName: string = ''; 
  CardType: string = ''; ;
  StreetAddress1: string = ''; 
  StreetAddress2: string = ''; 
  City: string = '';
  StateCode: string = ''; 
  CountryCode: string = ''; 
  PostalCode: string = ''; 
  PaymentTypeId: number = 0;
  CardMonthExpiration: number | undefined;
  CardYearExpiration: number | undefined;
  CardVerificationValue: string = '';

  constructor(payment?: Partial<Payment>) {
    Object.assign(this, payment);
  }
}
